import { useEffect } from "react";
import { ReferenceInput, required, SelectInput, useChoicesContext } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { studentRequests } from "api/studentApi";
import { getAcademicYearIdForSeason } from "../utils";

// Prefills the academic year from the picked season, but only while the field is
// still empty - an already chosen year is never overwritten.
const SeasonAcademicYearDefault = () => {
  const { allChoices } = useChoicesContext();
  const { setValue } = useFormContext();
  const season = useWatch({ name: "campaignSeason" });
  const academicYearId = useWatch({ name: "academicYearId" });

  useEffect(() => {
    if (!season || academicYearId || !allChoices?.length) return;

    const suggestedId = getAcademicYearIdForSeason(allChoices, season);

    if (suggestedId) setValue("academicYearId", suggestedId);
  }, [season, academicYearId, allChoices, setValue]);

  return null;
};

const AcademicYearInput = () => {
  return (
    <ReferenceInput
      source="academicYearId"
      reference={studentRequests.getAcademicYearsSelect()}
    >
      <SeasonAcademicYearDefault />
      <SelectInput
        label="Учебна година"
        fullWidth
        validate={required()}
      />
    </ReferenceInput>
  );
};

export default AcademicYearInput;
